// crossectionGenerator.js
var CrossectionGenerator = pc.createScript('crossectionGenerator');

CrossectionGenerator.attributes.add('tPlanet', {type:'entity'});
CrossectionGenerator.attributes.add('crossRings',{type:'entity', array:true});
CrossectionGenerator.attributes.add('hemiSpheres',{type:'entity', array:true});
CrossectionGenerator.attributes.add('sections', {type:'entity', array:true});
CrossectionGenerator.attributes.add('velCurve', {type: 'curve', curves: [ 'x', 'y', 'z' ] });
CrossectionGenerator.attributes.add('sizeCurve', {type: 'curve'});
CrossectionGenerator.attributes.add('noiseMaps', { type:'asset', assetType:'texture', array:true});

// initialize code called once per entity
CrossectionGenerator.prototype.initialize = function() {
    
    
    
    this.seedScript = this.app.root.findByName('SEEDER').script.seeder;
    this.theSeed = 0.0;
    this.randomize = 0.0;
    
    this.oldLayers = [];
    
    
    
    // new layers
    var baseLayer = this.app.scene.layers.getLayerByName('crossPlanet');
    var citLayer = this.app.scene.layers.getLayerByName('crossCities');
    var ocLayer = this.app.scene.layers.getLayerByName('crossOcean');
    var cldLayer = this.app.scene.layers.getLayerByName('crossClouds');
    var sFlareLayer = this.app.scene.layers.getLayerByName('sunflareMask');
    var ggoverlayLayer = this.app.scene.layers.getLayerByName('floor');
    
    //oldLayers
    var planetLayer = this.app.scene.layers.getLayerByName('planet');
    var oceanLayer = this.app.scene.layers.getLayerByName('ocean');
    var cloudLayer = this.app.scene.layers.getLayerByName('clouds'); 
    var citiesLayer = this.app.scene.layers.getLayerByName('cities');
    var abClouds = this.app.scene.layers.getLayerByName('aboveClouds');
    
    var msk = this.app.scene.layers.getLayerByName('mask');
    
    this.mskLayer = new Array(0);
    this.mskLayer.push(msk.id);
    
    this.newLayers = new Array(0);
    this.newLayers.push(baseLayer.id);

    this.newCitLyr = new Array(0);
    this.newCitLyr.push(cldLayer.id);

    this.newOcLayer = new Array(0);
    this.newOcLayer.push(ocLayer.id);
    
    this.newcldLayer = new Array(0);
    this.newcldLayer.push(cldLayer.id);
    
    this.newSunFlare = new Array(0);
    this.newSunFlare.push(sFlareLayer.id);
    
    this.newGGOverlay = new Array(0);
    this.newGGOverlay.push(ggoverlayLayer.id);
  //  console.log('LAYER: ' + ggoverlayLayer.name + ' ' + ggoverlayLayer.id);
    
    this.oldPlanetLayers = new Array(0);
    this.oldPlanetLayers.push(planetLayer.id);
    
    this.oldOceanLayers = new Array(0);
    this.oldOceanLayers.push(oceanLayer.id);
    
    this.oldCloudLayers = new Array(0);
    this.oldCloudLayers.push(cloudLayer.id);
    
    this.oldCivLayers = new Array(0);
    this.oldCivLayers.push(citiesLayer.id);
    
    this.oldAbClouds = new Array(0);
    this.oldAbClouds.push(abClouds.id);
    
    this.activeRing = 0;
    //this.splitPlanet(this.tPlanet);#
    this.sunScript = null;
    this.giantScript = null;
    this.rockScript = null;
    this.baseSun = null;
    this.overlaySun = null;
    this.particles = 0;
    this.oldVeloGraph = new pc.Curve();
    this.size = 0;
    this.c1 = 0;
    this.c2 = 0;
    this.scs = new pc.Vec3();
    this.startScs = new pc.Vec3(0.68,0.68,0.68);
    this.sunBaseColor = null;
    this.stations = null;
    this.hideStations = [];
    this.rings = [];
    this.doRot = 0;
    this.theClouds = null;
    this.theSystem = null;
    this.lastPlanet  = null;
    
    this.rockCrossMats = this.sections[0].children[2].model.meshInstances; 
    this.gasCrossMats = this.sections[1].children[2].model.meshInstances;
    this.sunCrossMats = this.sections[2].children[2].model.meshInstances;
    
    this.app.on('uiGenerator:crossSectionOn', this.splitPlanet, this);
    this.app.on('uiGenerator:crossSectionOff', this.resetPlanet, this);
};


CrossectionGenerator.prototype.splitPlanet = function(planet){
    
    this.lastPlanet = planet;

    if(planet.parent.name == 'system'){
        this.sunScript = planet.script.sunGenerator;
        this.rings = [];//excludes scanning for rings in case of sun
    } else {
        this.rings = planet.findByTag('ring');
    }

    
    this.activeRing = null;

    if(this.rings.length !== 0){
        for(var a = 0; a < 3; a++){
            if(this.rings[a].enabled){
                this.activeRing = a;
                this.rings[a].enabled = false;
            }
        }
        
        if(this.activeRing !== null){
            this.crossRings[this.activeRing].enabled = true;
            if(planet.name == 'gasGiant'){
                this.crossRings[this.activeRing].setLocalScale(7,7,7);
            } else {
                this.crossRings[this.activeRing].setLocalScale(2.471,2.471,2.471);
            }
        }
    }

    
    this.entity.children[0].enabled = true;
    this.entity.setPosition(planet.getPosition());
    this.size = 0;
    
    this.hemiSpheres[0].enabled = false;
    this.hemiSpheres[1].enabled = false;
    this.hemiSpheres[2].enabled = false;
    this.sections[0].enabled = false;
    this.sections[1].enabled = false;
    this.sections[2].enabled = false;
    
    if(planet.children[0].name == 'overlaySphere'){
        this.theSystem = planet;
        this.lastPlanet = this.theSystem; // LATEST FIX PELLWORM
        //get sunscript
        this.sunScript = planet.script.sunGenerator;
        
        //define atmosphere object and size variable from sunscript
        this.size = this.sunScript.rndSize / 6.37;
        //enable entities for masking and crossecting
        this.hemiSpheres[2].enabled = true;
        this.sections[2].enabled = true;
        
        //get basescale of sun mask and crossection
        var hbs = this.hemiSpheres[2].getLocalScale();
        this.scs = this.sections[2].getLocalScale();
        
        //define objects
        this.baseSun = planet.children[1];
        this.overlaySun = planet.children[0];
        this.particles = planet.findByTag('particles');
        // oldvelocityGraph
        this.oldVeloGraph = this.particles[0].particlesystem.velocityGraph;
        //particle loop
        for(var sn = 0; sn < this.particles.length; sn++){
            //set layers
            this.particles[sn].layers = this.newcldLayer;
            if(sn < this.particles.length-1){
                this.particles[sn].particlesystem.scaleGraph = this.sizeCurve;
            }           
            var psPos = this.particles[sn].getPosition();
            var psSize = this.particles[sn].getLocalScale();
            this.particles[sn].layers = this.newSunFlare;
            this.particles[sn].setPosition(psPos.x, psPos.y, psPos.z - this.size*50);
            this.particles[sn].setLocalScale(psSize.x/1.15, psSize.y/1.15, psSize.z/1.15);
            this.particles[sn].particlesystem.velocityGraph = this.velCurve;
            this.particles[sn].particlesystem.rebuild();
        }
        
        var hmSize = this.size*5;

        this.hemiSpheres[2].setLocalScale(hbs.x * hmSize, hbs.y * hmSize, hbs.z * hmSize);
        this.sections[2].setLocalScale(this.scs.x * this.size, this.scs.y * this.size, this.scs.z * this.size);

        this.baseSun.children[0].children[0].reparent(this.baseSun, 1);
        //console.log('nm: ' + this.baseSun.children[0].children[1].name);
        this.baseSun.children[0].children[1].reparent(this.baseSun, 2);

        this.baseSun.children[1].setLocalPosition(0,0,0);
        this.baseSun.children[2].setLocalPosition(0,0,0);
        this.c1 = this.baseSun.children[1].getLocalScale();
        this.c2 = this.baseSun.children[2].getLocalScale();
        
        this.baseSun.children[1].setLocalScale(this.c1.x / 45.5, this.c1.y / 45.5, this.c1.z / 45.5);
        this.baseSun.children[2].setLocalScale(this.c2.x / 45.5, this.c2.y / 45.5, this.c2.z / 45.5);
        
        this.baseSun.model.model.meshInstances[0].visible = false;
        this.overlaySun.model.layers = this.newOcLayer;
       // this.hemiSpheres[2].model.layers = this.mskLayer;
        
        this.generateSection(planet);
        
    }
        
        
    if(planet.name == 'gasGiant'){
   
        //console.log('PLANETNAME: ' + planet.children[1].children[0].children[0].name);
        this.hemiSpheres[1].enabled = true;
        this.sections[1].enabled = true;
       // console.log('planet: ' + planet.children[1].name);
        planet.children[1].children[0].children[0].script.enabled = false;
        this.hemiSpheres[1].lookAt(0,0,0);
        this.doRotation(1);
        var baseGiant = planet.children[1].children[1];
        var overlayGiant = planet.children[1].children[2];
        
        planet.children[1].children[0].children[0].setLocalEulerAngles(0,0,0); //atmospheric glow
        //console.log(planet.children[1].children[0].children[0].children[1]);
        planet.children[1].children[0].children[0].children[1].enabled = false;
        
      //  console.info(overlayGiant.model.layers);
        overlayGiant.model.layers = this.newcldLayer;

       // console.info(overlayGiant.model.layers);
        baseGiant.model.layers = this.newLayers;

      //  console.info(overlayGiant);

        
        this.giantScript = planet.children[1].script.gasGiantGenerator;
        
        
        this.stations = planet.children[2].children;
        
        for(var stn = 0; stn < this.stations.length; stn++){
        var sRot = this.stations[stn].getLocalEulerAngles().y;
        //console.log('nm: ' + this.stations[stn].name + ' rot: ' + this.stations[stn].getLocalEulerAngles().y, 'enbl: ' + this.stations[stn].enabled);
           // console.log('stations: ' + this.stations[stn].enabled);
            if(this.stations[stn].enabled){
                if( sRot > -90 && sRot < 90){
                    this.hideStations.push(this.stations[stn]);
                    this.stations[stn].enabled = false;
                }
            }
        }
        this.generateSection(planet);
    }
      
    if(planet.children[1].name == 'proceduralPlanet' || planet.children[1].name == 'hotRockPlanet' ||  planet.children[1].name == 'coldRockPlanet'){
        
        var clouds = null;
        
        if(planet.children[1].name == 'hotRockPlanet'){
            this.sections[0].setLocalScale(1.023,1.023,1.023);
            this.hemiSpheres[0].setLocalScale(1.22,1.22,1.22);
        } else if(planet.children[1].name == 'proceduralPlanet' || planet.name == 'coldRockPlanet'){
            this.sections[0].setLocalScale(1.1,1.1,1.1);
            this.hemiSpheres[0].setLocalScale(1.32,1.32,1.32);
        }
        var cldAr = planet.children[1].children[4].children;
       // console.log('CLOUDAR: ');
      //  console.info(planet.children[1].children[4].children);
        if(cldAr.length > 1){
            for(var cldCnt = 1; cldCnt < cldAr.length; cldCnt++){
                if(cldAr[cldCnt].enabled){
              //      console.log('cloudsMulti');
                    clouds = cldAr[cldCnt];
                }
            }
        } else {
            clouds = planet.children[1].children[4];      
         //   console.log('cloudsSingle');
        }
        this.theClouds = clouds;
       //console.info(this.theClouds.model.layers);
        
        this.hemiSpheres[0].enabled = true;
        this.sections[0].enabled = true;
        this.hemiSpheres[0].lookAt(0,0,0);
        this.doRotation(0);
        planet.children[1].children[0].enabled = false;
        var base = planet.children[1].children[1]; 
        var bio1 = planet.children[1].children[2];
        var bio2 = planet.children[1].children[3];
        
        var ocean = planet.children[1].children[5];
        var civ = planet.children[1].children[6];
        this.oldLayers = base.model.layers;
       
        
        base.model.layers = this.newLayers;
        bio1.model.layers = this.newLayers;
        bio2.model.layers = this.newLayers;
        if(clouds !== null){
            clouds.model.layers = this.newcldLayer;
        }
        if(ocean !== null){
          ocean.model.layers = this.newOcLayer;  
        }
        if(civ !== null){
           civ.model.layers = this.newCitLyr; 
        }
        
        
        
        this.generateSection(planet);
    }
};

CrossectionGenerator.prototype.doRotation = function(act){
    
    this.hrot = this.hemiSpheres[act].getLocalEulerAngles();
    if(this.hrot.x === 0){
        this.sections[act].setLocalEulerAngles(this.hrot.x,this.hrot.y + 90,this.hrot.z);
        if(this.activeRing !== null){
            this.crossRings[this.activeRing].setLocalEulerAngles(this.hrot.x,this.hrot.y+135,this.hrot.z);
        }
        } else {
            this.sections[act].setLocalEulerAngles(this.hrot.x,this.hrot.y - 90,this.hrot.z);
            if(this.activeRing !== null){
                this.crossRings[this.activeRing].setLocalEulerAngles(this.hrot.x,this.hrot.y-135, this.hrot.z);
            }
        }
};



CrossectionGenerator.prototype.resetPlanet = function(planet){
    //console.log('RESET');
    //console.info(this.rings[this.activeRing].model.layers);
        this.hemiSpheres[1].enabled = false;
        this.hemiSpheres[0].enabled = false;
        this.sections[0].enabled = false;
        this.sections[1].enabled = false;
        this.hemiSpheres[2].enabled = false;
        this.sections[2].enabled = false;
    planet = this.lastPlanet;
    if(planet.children[0].name == 'overlaySphere'){
       
        this.baseSun.children[1].reparent(this.baseSun, 0);
        this.baseSun.children[2].reparent(this.baseSun, 2);
        this.baseSun.model.model.meshInstances[0].visible = true;
        this.overlaySun.model.layers = this.oldAbClouds;
        
        for(var p = 0; p < this.particles.length; p++){
            var pp = this.particles[p].getPosition();
            var ps = this.particles[p].getLocalScale();
            this.particles[p].layers = this.oldCloudLayers;
            this.particles[p].setPosition(pp.x, pp.y, pp.z + this.size*50);
            this.particles[p].setLocalScale(ps.x*1.15, ps.y*1.15, ps.z*1.15);
            this.particles[p].particlesystem.velocityGraph = this.oldVeloGraph;
            this.particles[p].particlesystem.rebuild();
        }


        this.sections[2].setLocalScale(2.83, 2.83, 2.83);
        this.hemiSpheres[2].setLocalScale(0.68, 0.66, 0.66);
        
        this.baseSun.children[0].reparent(this.baseSun.children[1], 0);
        this.baseSun.children[1].reparent(this.baseSun.children[0], 2);

        this.baseSun.children[0].children[0].setLocalScale(this.c1.x * 45.5, this.c1.y * 45.5, this.c1.z * 45.5);
        this.baseSun.children[0].children[2].setLocalScale(this.c2.x * 45.5, this.c2.y * 45.5, this.c2.z * 45.5);
     }
    
     if(planet.name == 'gasGiant'){

        var baseGiant = planet.children[1].children[1];
        var overlayGiant = planet.children[1].children[2];
        baseGiant.model.layers = this.oldPlanetLayers;
        overlayGiant.model.layers = this.oldCloudLayers;
        planet.children[1].children[0].children[0].children[1].enabled = true;
        planet.children[1].children[0].children[0].script.enabled = true;
        for(var stnEn = 0; stnEn < this.hideStations.length; stnEn++){
            this.hideStations[stnEn].enabled = true;
        }
     }
    
    
    if(planet.children[1].name == 'proceduralPlanet' || planet.children[1].name == 'hotRockPlanet' ||  planet.children[1].name == 'coldRockPlanet'){
        
        planet.children[1].children[0].enabled = true;
        var base = planet.children[1].children[1];
        var bio1 = planet.children[1].children[2];
        var bio2 = planet.children[1].children[3];
        var clouds = this.theClouds;
        var ocean = planet.children[1].children[5];
        var civ = planet.children[1].children[6];

        //console.log('civ: ' + civ.name);
        base.model.layers = this.oldPlanetLayers;
        bio1.model.layers = this.oldPlanetLayers;
        bio2.model.layers = this.oldPlanetLayers;

        ocean.model.layers = this.oldOceanLayers;
        if(clouds !== null){
            
         //   console.info(this.oldCloudLayers);
          //console.info(clouds.model.layers);
            
            clouds.model.layers = this.oldCloudLayers;
        }

        civ.model.layers = this.oldCivLayers;

        this.sections[0].setLocalScale(1.065,1.065,1.065);
        this.hemiSpheres[0].setLocalScale(1.32,1.32,1.32);
        this.entity.children[0].enabled =false;
    }        
    
    if(this.activeRing !== null){
        this.crossRings[this.activeRing].enabled = false;
        this.rings[this.activeRing].enabled = true;   
        this.crossRings[this.activeRing].setLocalScale(2.471,2.471,2.471);
        this.crossRings[this.activeRing].enabled = false;
        this.rings[this.activeRing].enabled = true;
    }
    
};

CrossectionGenerator.prototype.generateSection = function(gPlanet){
    
    var mySeed = this.seedScript.seed;
    this.randomize = new Math.seedrandom(this.seedScript.getUniqueRandom()+this.entity.name);

    if(gPlanet.children[0].name == 'overlaySphere'){
        var layerSn = this.sunCrossMats[1].material;
        var innerLayerSnMat = this.sunCrossMats[2].material;
        var outerLayerSnMat = this.sunCrossMats[3].material;
        var bgSnMat = this.sunCrossMats[4].material;
        var cupSn = this.sections[2].children[1];

        rScl1 = 0.5 + (this.randomize()/5);
        rScl2 = 2.44 + (this.randomize());
        this.sunCrossMats[1].node.setLocalScale(rScl1, rScl1, rScl1);
        cupSn.setLocalScale(rScl2, rScl2, rScl2);
        var clr = this.sunScript.baseColor;

        outerLayerSnMat.emissiveMap = this.noiseMaps[Math.floor(this.randomize()*10)].resource;
        var iv = 1;
        outerLayerSnMat.diffuse = new pc.Color(clr.r / iv, clr.g / iv, clr.b / iv);
        outerLayerSnMat.emissive = new pc.Color(clr.r / iv, clr.g / iv, clr.b / iv);
        outerLayerSnMat.update();

        innerLayerSnMat.emissiveMap = this.noiseMaps[Math.floor(this.randomize()*10)].resource;
        innerLayerSnMat.emissiveMapTiling.x = (1 + this.randomize()*2) * -1;
        innerLayerSnMat.update();
        var mv = 2;
        bgSnMat.emissive = new pc.Color(clr.r * mv, clr.g * mv, clr.b * mv);
        bgSnMat.update();
        
        var dColor = new pc.Color(clr.r + 0.2, clr.g + 0.2, clr.b + 0.2, 1);
        layerSn.emissiveMap = this.noiseMaps[Math.floor(this.randomize()*10)].resource;
        layerSn.diffuse = dColor;
        layerSn.emissive = dColor;
        layerSn.update();        
    }  

    //gasGiant
    if(gPlanet.name == 'gasGiant'){
        
        var gColor = gPlanet.children[1].script.gasGiantGenerator.colors;
        
        var gCup = this.sections[1].children[1].model.meshInstances[0].material;
        var gBackPlate = this.sections[1].children[5].model.meshInstances[0].material;
        var gOuterCore = this.gasCrossMats[0].material;
        var gInnerLayer = this.gasCrossMats[1].material;
        var gOuterLayer = this.gasCrossMats[2].material;
        var gLayer = this.gasCrossMats[4].material;
        var gBg = this.gasCrossMats[3].material;
        var gHalo = this.sections[1].children[4].children[0].model.meshInstances[0].material;
        this.sections[1].children[4].enabled = true;
        var tex = this.giantScript.theColorMap;
        gOuterCore.diffuseMap = tex; 
        gOuterCore.update();
        gLayer.diffuseMap = tex;
        gLayer.update();
        gInnerLayer.diffuseMap = tex; 
        gInnerLayer.update();
        gBackPlate.diffuseMap = tex;
        gBackPlate.update();
        gOuterLayer.emissiveMap = this.noiseMaps[Math.floor(this.randomize()*10)].resource;
        gOuterLayer.diffuseMap =  tex;
        gOuterLayer.update();
        gBg.diffuseMap = tex; 
        gBg.update();
        var dimm = 2;
        gHalo.emissive = gHalo.diffuse = new pc.Color(gColor.r / dimm, gColor.g / dimm, gColor.b / dimm);
        gHalo.update();
        var val = 5;
        gCup.emissive = new pc.Color(gColor.r / val, gColor.g / val, gColor.b / val);
        gCup.update();  
        var gScl1 = 3 + (this.randomize());
        var gScl2 = 0.5 + this.randomize()/2;
        var gScl3 = 0.72 + this.randomize()/4;
        this.gasCrossMats[0].node.setLocalScale(gScl2, gScl2, gScl2);
        this.sections[1].children[1].setLocalScale(gScl1, gScl1, gScl1);
        this.gasCrossMats[1].node.setLocalScale(gScl3, gScl3, gScl3);    
    }
    
    //rockPlanet
    if(gPlanet.children[1].name == 'proceduralPlanet' || gPlanet.children[1].name == 'hotRockPlanet' ||  gPlanet.children[1].name == 'coldRockPlanet'){

        var rCup = this.sections[0].children[1];
        var rOuterCore = this.rockCrossMats[0].material;
        var rLayer = this.rockCrossMats[1].material;
        var rInnerLayer = this.rockCrossMats[2].material;
        var rOuterLayer = this.rockCrossMats[3].material;
        rOuterCore.emissiveMap = this.noiseMaps[Math.floor(this.randomize()*10)].resource;
        rOuterCore.update();
        rInnerLayer.emissiveMap = this.noiseMaps[Math.floor(this.randomize()*10)].resource;
        rInnerLayer.update();
        
        var rSclRnd1 = 0.5 + (this.randomize()/2.5);
        var rSclRnd2 = 0.75 + (this.randomize() / 2);
        
        rCup.setLocalScale(rSclRnd2, rSclRnd2, rSclRnd2);
        this.rockCrossMats[0].node.setLocalScale(rSclRnd1, rSclRnd1, rSclRnd1);
        this.rockCrossMats[1].node.setLocalScale(rSclRnd1 + 0.05, rSclRnd1 + 0.05, rSclRnd1 + 0.05);
        //rOuterLayer.emissiveMap = this.noiseMaps[Math.floor(this.randomize()*10)].resource;
        //rOuterLayer.diffuseMap = this.noiseMaps[Math.floor(this.randomize()*10)].resource;
       
        //{
        rOuterLayer.diffuseMapTiling.x = 0.75 + this.randomize();
        rOuterLayer.diffuseMapTiling.y = 0.75 + this.randomize() * 2.25;
        rOuterLayer.emissiveMapTiling.x = 12 + this.randomize() * 10;
        rOuterLayer.emissiveMapTiling.y = 2 + this.randomize() * 6;
        
        //}
        
        rOuterLayer.update();
    }
    
};


// update code called every frame
CrossectionGenerator.prototype.update = function(dt) {
    // if (this.app.keyboard.wasReleased(pc.KEY_A)) {
    //     this.splitPlanet(this.tPlanet);
    // }
    // if (this.app.keyboard.wasReleased(pc.KEY_D)) {
    //     this.resetPlanet(this.tPlanet);
    // }    
};

// swap method called for script hot-reloading
// inherit your script state here
// CrossectionGenerator.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

